import { useMutation, useQueryClient } from "@tanstack/react-query";
import { odataFetch } from "../../lib/odata-fetch";
import { createQueryBuilderV4 } from "@odata2ts/odata-query-builder";
import { QSetEquipmentPreferencesForUser } from "../../odata/appu4dm/QAppU4DM";
import {
  SetEquipmentPreferencesForUser2Params,
  SetEquipmentPreferencesForUserResponse,
} from "../../odata/appu4dm/AppU4DMModel";
import { resetMachine } from "./use-reset-machine";

export function useSetMachine(onSuccess?: VoidFunction) {
  const queryClient = useQueryClient();
  const { token } = queryClient.getDefaultOptions().queries?.meta ?? {};

  const { mutate, ...mutation } = useMutation({
    mutationFn: (machineId: string) => updateMachine(machineId, token!),
    onSuccess: async () => {
      await queryClient.invalidateQueries();
      onSuccess?.();
    },
  });

  return {
    setMachine: mutate,
    ...mutation,
  };
}

async function updateMachine(machineId: string, token: string) {
  const builder = createQueryBuilderV4(
    "SetEquipmentPreferencesForUser",
    new QSetEquipmentPreferencesForUser()
  );

  await resetMachine(token).catch(() => {
    // ignore errors when resetting machine here
  });

  return odataFetch<
    SetEquipmentPreferencesForUserResponse,
    SetEquipmentPreferencesForUser2Params
  >({
    builder,
    token,
    method: "POST",
    body: { command: { EquipmentNId: machineId } },
  });
}
